<div [formGroup]="form">
    <div class="row">
        <div *ngIf="form.value.identifier" class="form-group" [ngClass]="(form.value.identifier)?'col-lg':'col-lg-4'">
            <apc-form-input [class]="'form-control autogenerated'" [disabled]="true" formControlName="code" [type]="'text'">
               <label label>{{'administration.sectionsManagement.profile.code' | translate}}</label>
            </apc-form-input>
        </div>
        <div class="form-group" [ngClass]="(form.value.identifier)?'col-lg-6':'col-lg'">
            <apc-form-input [class]="'form-control'" formControlName="name" [type]="'text'" [isRequired]="true">
                <label label>{{'administration.sectionsManagement.profile.name' | translate}}</label>
            </apc-form-input>
        </div>
        <div class="form-group col-lg" [ngClass]="(form.value.identifier)?'col-lg-6 mt-3':'col-lg'">
            <apc-form-input [class]="'form-control'" formControlName="description" [type]="'text'" [isRequired]="false">
                <label label>{{'administration.sectionsManagement.profile.description' | translate}}</label>
            </apc-form-input>
        </div>
        <div class="form-group col-lg" [ngClass]="(form.value.identifier)?'col-lg-6 mt-3':'col-lg'">
            <apc-form-select [disabled]="readDisable" formControlName="restrictionMode" [items]="mode" optionValue="value" [renderValue]="form.value.restrictionMode" [isRequired]="true">
                <label label>{{'administration.sectionsManagement.profile.mode' | translate}}</label>
            </apc-form-select>
        </div>
    </div>
    <div class="row">
        <div *ngIf="type == 'customfield'" class="form-group mt-3"
            [ngClass]="(form.value.identifier)?'col-lg-6':'col-lg-4'">
            <apc-form-select [disabled]="readDisable" formControlName="customFieldType" [items]="customFields" optionValue="value" [renderValue]="form.value.customFieldType"  [isRequired]="true">
                <label label>{{'administration.sectionsManagement.profile.customFieldType' | translate}}</label>
            </apc-form-select>
        </div>
    </div>